import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { levels } from '../levels';
import { getGameProgress } from '../utils/storage';
import styles from './LevelsPage.module.css';

const LevelsPage = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    const fetchProgress = async () => {
      const gameProgress = await getGameProgress();
      setProgress(gameProgress);
    };
    fetchProgress();
  }, []);

  if (!progress) return <div>Loading...</div>;

  return (
    <div className={styles.container}>
      <h1>Select Level</h1>
      <div className={styles.grid}>
        {levels.map(level => (
          <button
            key={level.id}
            onClick={() => navigate(`/game/${level.id}`)}
            disabled={level.id > progress.completedLevels.length + 1}
          >
            Level {level.id} {progress.completedLevels.includes(level.id) ? '✓' : ''}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LevelsPage;